<template>
    <div id="ContractCPITabView">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <template v-if="isupdate==false && rateFound==false">
            <h5>No Section/CPI Rate Data Found...</h5>
        </template>
        <div class="table-responsive-sm" v-if="isupdate==false && rows && rows.length > 0">
            <table aria-describedby="table" id="" class="table table-sm table-bordered font-1">
                <thead>
                    <tr class="table-primary">
                        <th>Section</th>
                        <th style="text-align:right">Rate($)</th>
                        <th style="text-align:right" v-if="!cpi_waived">CPI(%)</th>
                        <th style="text-align:right" v-if="!cpi_waived">Rate(%)</th>
                        <th style="text-align:right" v-if="!cpi_waived">Limit(%)</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="rows && rows.length > 0">
                        <template v-for="(record, index) in rows">
                            <tr v-bind:key="'recordRow'+index">
                                <td>{{record.srName}}</td>
                                <td style="text-align:right">{{record.section_value}}</td>
                                <td style="text-align:right" v-if="!cpi_waived && record.section_type != 'penalty'">{{record.cpi_increase_percent}}</td>
                                <td style="text-align:right" v-if="!cpi_waived && record.section_type != 'penalty'">{{record.rate_increase_percent}}</td>
                                <td style="text-align:right" v-if="!cpi_waived && record.section_type != 'penalty'">{{record.limit_percent}}</td>
                            </tr>
                        </template>
                    </template>
                    <template v-else>
                        <tr><td colspan="5" class="text-center">No Record Found</td></tr>
                    </template>
                </tbody>
            </table>
        </div>
      <template v-else>
        <form autocomplete="off" class="form-horizontal basic-form-container add-user-form-title "
              id="ContractAssetDetailForm">
          <div class="alert-contract field-error hide"></div>
          <div class="row">
            <div class="col form-group">
              <label class="control-label require" for="section.id">Section:</label>
            </div>
            <div class="col form-group">
              <label class="control-label require" for="section_value">Rate:</label>
            </div>
            <div class="col form-group" v-if="is_add_rate">
              <label class="control-label require" for="section_value">Effective Date:</label>
            </div>
             <div class="col form-group" v-if="is_add_rate">
              <label class="control-label" for="section_value">Comment:</label>
            </div>
            <div class="col form-group" v-if="!cpi_waived">
              <label class="control-label" for="section_value" v-if="!is_add_rate">CPI Rate:</label>
              <label class="control-label" for="section_value" v-else>Action:</label>
            </div>
          </div>
          <div class="row" v-for="(section, index) in sectionratesArr" v-bind:key="index">
            <input type="hidden" class="form-control" v-model="section.id" placeholder="" name="rate_id">
            <div class="col form-group">
              <v-select class="section-id" :disabled="close" v-model="section.section_id"
                        @change="onSectionChange($event,index,'change')" name="rate_section_id"
                        placeholder="Select Section"
                        label="text"
                        :options="sectionTypes">
              </v-select>
              <div class="field-error">{{ section.section_error_msg }}</div>
            </div>
            <div class="col form-group">
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">$</div>
                </div>
                <input type="text" :disabled="close" ref="infoBox" class="form-control text-right"
                       v-model="section.section_value" id="section_value" placeholder="Section Value"
                       name="section_value" aria-describedby="basic-addon3" @keypress="isAmountCheck($event)">
              </div>
              <div class="field-error">{{ section.section_value_error_msg }}</div>
            </div>
            <div class="col form-group" v-if="is_add_rate">
              <date-picker placeholder="MM/DD/YYYY" id="cpi_effective_date" :config="optionsDate" name="cpi_effective_date"
                           v-model="section.cpi_effective_date" for></date-picker>
              <div class="field-error">{{ section.effective_date_error_msg }}</div>
            </div>
             <div class="col form-group" v-if="is_add_rate">
              <div class="input-group">
                <textarea type="text" :disabled="close" ref="infoBox" class="form-control"
                       v-model="section.comment" id="comment" placeholder="Comment"
                       name="comment"></textarea>
              </div>
            </div>
            <div class="col form-group" v-if="!cpi_waived && !is_add_rate">
              <v-select v-model="section.cpi_rate_id" name="contract_cpi_rate_id" v-show="section.section_id == null || section.section_id.section_type == '' || section.section_id.section_type == undefined || section.section_id.section_type != 'penalty'" placeholder="Select CPI Rate."
                        label="text"
                        :options="cpiRateArr">
              </v-select>
              <div class="field-error">{{ section.cpi_rate_error_msg }}</div>
            </div>
            <div class="col form-group">
              <template v-if="sectionratesArr.length != 1">
                <a href="" class="fp-remove" v-on:click.prevent="removeLine(index,section.id)"></a>
              </template>
              <label>&nbsp;&nbsp;</label>
              <template>
                <a href="" class="fp-plus" v-if="index + 1 === sectionratesArr.length"
                   v-on:click.prevent="addLine($event,index)"></a>
              </template>
            </div>
          </div>
          <template v-if="isContractAsset==true">
            <button type='button' v-if="isupdate===true && is_add_rate===false" title="Edit Asset" class="btn btn-primary"
                    v-on:click="createCPiRate()">
              <i class="fp-save"> </i> Save
            </button>
            <button type='button' v-if="is_add_rate===true" title="Edit Asset" class="btn btn-primary"
                    v-on:click="createCPiRateForAdd()">
              <i class="fp-save"> </i> Save
            </button>
            <button type='button' v-if="isupdate==true" title="Edit Asset" class="btn btn-tertiary"
                    v-on:click="backCPiRateList()">
              <i class="fp-close"> </i> Cancel
            </button>
          </template>
        </form>
      </template>
      <template v-if="isClosed==0">
        <div class="btn-groups text-right mb-4">
          <button v-if="isupdate===false && isContractAsset===true" title="Edit Asset" class="btn btn-primary"
                  v-on:click="loadCPiRate(false,'')">
            <i class="fp-edit-icon"> </i> Edit
          </button>
          <button v-if="isupdate===false && isContractAsset===true" title="Add Asset" class="btn btn-primary"
                  v-on:click="loadCPiRate(true,'add')">
            <i class="fp-add"> </i> Add
          </button>
        </div>
      </template>
    </div>
</template>
<script>
    import {commonMixins} from '../mixins/commonMixins';
    export default {
        name: "ContractCPITabView",
        mixins:[commonMixins],
        props:{
          rateHistoryId:{
            type: Number,
            required: false,
            default: undefined
          }
        },
        data: () => ({
            checkCol:true,
            role:"",
            assetArr: [],
            contractSectionArr: [],
            // sectionRateArr: [],
            // tempArr: [],
            loading:false,
            sectionTypes:[],
            sectionratesArr: [],
            isupdate:false,
            blockRemoval: true,
            close:false,
            isContractAsset:false,
            rows:null,
            isClosed:0,
            rateFound:false,
            cpiRateArr:[],
            cpiRateId:0,
            cpi_waived:false,
            is_add_rate: false,
            optionsDate: {
              format: 'MM/DD/YYYY',
              useCurrent: false,
            },
            history_section_id:'',
            rate_history_id:'',
            from_history :false
        }),
        created: function() {

        },
        watch:{
            sectionratesArr() {
                var self = this;
                self.blockRemoval = self.sectionratesArr.length <= 1
            },
            // rate_history_id: function(val) {
            //     var self = this;
            //     // self.$refs.contract_rate_tab.rate_history_id = val;
            //     // self.$refs.contract_rate_tab.history_section_id = self.history_section_id;
            //     alert('hhhiii');
            //     self.from_history = true;
            //     self.getRateHistoryData(val, history_section_id);
            // },
        },
        mounted: function() {

            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            console.log(segments);
            if(segments[1]=='contractassetdetail')
            {
                self.isContractAsset=true;
            }
            if (self.rateHistoryId != undefined && self.rateHistoryId != ''){
              self.loadCPiRate(true,'update')
              // self.getRateHistoryData(self.rateHistoryId);
            }else{
              self.ContractCPIRateData();
            }
            setTimeout(function(){
              self.isClosed= self.$parent.closed;
            },500)

        },
        methods: {
            getContrgetContractRate(contract_id, is_add){
                 var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                self.loading=true;
                self.addRate=false;

                $.ajax({
                    url: process.env.ROOT_API + "/contract/cpirate",
                    type: "POST",
                    data: {"contract_id":contract_id,flag:'for_contract_select'},
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        self.getSectionRates(is_add);
                        if (data.status == "success") {
                            // console.log(data)
                            self.loading=false;

                            if(data.content.foundRate==true)
                            {
                               self.cpiRateArr=data.content.cpiRates;
                            }

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.getSectionRates();
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'contract-view-data')
                    }
                });
            },
            getRateHistoryData(rate_history_id) {
              const self = this;
              const path = window.location.pathname;
              self.loading = true;
              self.addRate = false;

              $.ajax({
                url: process.env.ROOT_API + "/contract/getRateHistory",
                type: "POST",
                data: {"rate_history_id": rate_history_id},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                  self.loading = false;
                  if (data.status === "success") {
                    console.log('data===', data)

                    self.sectionratesArr.push({
                        id:(data.content[0].id) ? data.content[0].id : 0,
                        section_id: (data.content[0].section_id != null && data.content[0].section_id != undefined) ? {
                                      value: data.content[0].section_id,
                                      text: data.content[0].section_name,
                                      code: data.content[0].section_code
                                    } : "",
                        section_value:  data.content[0].section_value,
                        cpi_rate_id: '',
                        // rate_increase_percent: null,
                        // limit_percent: null,
                        section_error_msg: "",
                        section_value_error_msg: "",
                        cpi_rate_error_msg: "",
                        cpi_effective_date:data.content[0].effective_date,
                        comment:data.content[0].comment,
                        section_type: data.content[0].section_type,
                        // rate_increase_error_msg: "",
                        // limit_percent_error_msg: "",
                    })
                    // self.id =
                    // self.section_id = (data.content[0].section_id != null && data.content[0].section_id != undefined) ? {
                    //   value: data.content[0].section_id,
                    //   text: data.content[0].name,
                    //   code: data.content[0].code
                    // } : "";
                    // self.section_value = data.content[0].section_value;
                    // if (data.content[0].ecr_id) {

                    //   self.cpi_rate_id = (data.content[0].cpi_percent != '') ? {
                    //     text: "CPI:" + data.content[0].cpi_percent + " | Rate:" + data.content[0].rate_increase_percent + " | Limit:" + data.content.limit_percent,
                    //     value: data.content[0].cpi_rate_id
                    //   } : '';

                    // } else {
                    //   self.cpi_rate_id = '';
                    // }
                    // self.cpi_effective_date = {value: data.content[0].effective_date, text: data.content[0].effective_date}
                    setTimeout(function () {
                      self.onSectionChange('', '', 'on_load');
                    }, 500);
                  }
                },
                error: function (jqXHR) {
                  self.getSectionRates();
                  self.loading = false;
                }
              });
            },
            backCPiRateList(){
                var self = this;
                var path = window.location.pathname;

                var segments = path.split("/");
                self.isupdate=false;
                self.ContractCPIRateData();
            },
            createCPiRate(){
                var self = this;
                var error = false;
                var sectionArr = [];
                var path = window.location.pathname;
                var segments = path.split("/");
                var checkNumber = /^[0-9]+(\.[0-9]+)?$/;

                    for (var i=0; i<self.sectionratesArr.length; i++) {

                        self.sectionratesArr[i].section_error_msg = "";
                        self.sectionratesArr[i].section_value_error_msg = "";
                        self.sectionratesArr[i].cpi_rate_error_msg = "";
                        self.sectionratesArr[i].rate_increase_error_msg = "";
                        self.sectionratesArr[i].limit_percent_error_msg = "";

                        if ( self.sectionratesArr[i].section_id != undefined && sectionArr.includes(self.sectionratesArr[i].section_id.value)) {
                            self.sectionratesArr[i].section_error_msg = " Section Rate has been already added.";
                            error = true;
                        }


                        if ( self.sectionratesArr[i].section_id == null || !self.sectionratesArr[i].section_id.value ) {

                            self.sectionratesArr[i].section_error_msg = "Section Rate Required.";
                            error = true;
                        } else {
                            sectionArr.push(self.sectionratesArr[i].section_id.value);
                        }

                        if (self.sectionratesArr[i].section_value == null || self.sectionratesArr[i].section_value == 0) {

                            self.sectionratesArr[i].section_value_error_msg = "Section Value Required.";
                            error = true;
                        } else {

                            //check amount is valid or not
                            if (self.sectionratesArr[i].section_value && self.sectionratesArr[i].section_value.includes(',')){
                                self.sectionratesArr[i].section_value = self.sectionratesArr[i].section_value.replace(',','');
                            }
                            if ( !self.sectionratesArr[i].section_value.match(checkNumber) ) {
                                self.sectionratesArr[i].section_value_error_msg = "Section Value is not valid.";
                                error = true;
                            }
                        }
                        // if (self.sectionratesArr[i].cpi_rate_id == null || self.sectionratesArr[i].cpi_rate_id == "") {

                        //     self.sectionratesArr[i].cpi_rate_error_msg = "CPI Rate Required.";
                        //     error = true;
                        // }
                        // if ( self.sectionratesArr[i].rate_increase_percent == null || self.sectionratesArr[i].rate_increase_percent == "" ) {

                        //     self.sectionratesArr[i].rate_increase_error_msg = "Rate Percent Required.";
                        //     error = true;
                        // } else {

                        //     if ( !self.sectionratesArr[i].rate_increase_percent.match(checkNumber) ) {
                        //         self.sectionratesArr[i].rate_increase_error_msg = "CPI Percent is not valid.";
                        //         error = true;
                        //     }

                        // }
                        // if (self.sectionratesArr[i].limit_percent == null || self.sectionratesArr[i].limit_percent == "" ) {

                        //     self.sectionratesArr[i].limit_percent_error_msg = "Limit Percent Required.";
                        //     error = true;
                        // } else {

                        //     if ( !self.sectionratesArr[i].limit_percent.match(checkNumber) ) {
                        //         self.sectionratesArr[i].limit_percent_error_msg = "Limit Percent is not valid.";
                        //         error = true;
                        //     }

                        // }

                    }

                  if (error==false) {

                        // var rateArr = [];
                        // var cpiArr = [];
                        var conCpiRateIdArr = [];
                        var sectioIdArr = [];
                        var sectionValueArr = [];
                        // var limitArr = [];
                        var conAssRateIdArr = [];

                        for (var i = 0; i<self.sectionratesArr.length;i++) {

                            conAssRateIdArr.push(self.sectionratesArr[i].id);
                            if (self.sectionratesArr[i].cpi_rate_id != null && self.sectionratesArr[i].cpi_rate_id.value && !self.cpi_waived){

                                conCpiRateIdArr.push(self.sectionratesArr[i].cpi_rate_id.value);

                            }
                            // rateArr.push(self.sectionratesArr[i].rate_increase_percent);
                            // cpiArr.push(self.sectionratesArr[i].cpi_rate_id);
                            sectioIdArr.push(self.sectionratesArr[i].section_id.value);
                            sectionValueArr.push(self.sectionratesArr[i].section_value);
                            // limitArr.push(self.sectionratesArr[i].limit_percent);
                        }

                    var fields = {
                                contract_asset_id:segments[3],
                                // rate: rateArr,
                                cpi: conCpiRateIdArr,
                                // limit: limitArr,
                                section_id: sectioIdArr,
                                section_val: sectionValueArr,
                                cnt_ast_rt_id: conAssRateIdArr,
                            };
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/contractassetcpidetail/create",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;

                            //Changing the value because we are loading CPI Rate history if we added new cpi rate
                            self.$parent.contractCpiRateHistoryVal="dontLoadList";

                           if (data.status == "success") {
                                var path = window.location.pathname;

                                var segments = path.split("/");
                                self.isupdate=false;
                                self.ContractCPIRateData();

                            }
                            else {
                                if (data.content.length > 0) {
                                    var err = "<ul>";
                                    $(".alert-contract").empty();

                                    for (var i = 0; i < data.content.length; i++) {
                                        err += "<li>" + data.content[i] + "</li>";
                                    }
                                    err += "</ul>";
                                    $(".alert-contract").append(err);
                                    $(".alert-contract").addClass("show");
                                    // $("#errorMsg").html(err);
                                    // $(".alert-warning").toggleClass("show");
                                    // setTimeout(function () {
                                        // $(".alert-warning").removeClass("show");
                                        // $(".alert-warning").addClass("hide");
                                    // }, 10000);
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'contract-asset-detail-create')
                        }
                    });
                  }
            },
          createCPiRateForAdd() {
            var self = this;
            var error = false;
            var sectionArr = [];
            var path = window.location.pathname;
            var segments = path.split("/");
            var checkNumber = /^[0-9]+(\.[0-9]+)?$/;

            for (var i = 0; i < self.sectionratesArr.length; i++) {
              self.sectionratesArr[i].section_error_msg = "";
              self.sectionratesArr[i].section_value_error_msg = "";
              self.sectionratesArr[i].cpi_rate_error_msg = "";
              self.sectionratesArr[i].rate_increase_error_msg = "";
              self.sectionratesArr[i].limit_percent_error_msg = "";
              self.sectionratesArr[i].effective_date_error_msg = "";

              if (!self.sectionratesArr[i].cpi_effective_date || self.sectionratesArr[i].cpi_effective_date == null || self.sectionratesArr[i].cpi_effective_date === "") {
                self.sectionratesArr[i].effective_date_error_msg = "Effective Date is required.";
                error = true;
              }
              if (self.sectionratesArr[i].section_id == null || !self.sectionratesArr[i].section_id.value) {
                self.sectionratesArr[i].section_error_msg = "Section Rate Required.";
                error = true;
              }

              if (self.sectionratesArr[i].section_value == null || self.sectionratesArr[i].section_value == "" || self.sectionratesArr[i].section_value == 0) {
                self.sectionratesArr[i].section_value_error_msg = "Section Value Required.";
                error = true;
              }

              if (self.sectionratesArr[i].section_id !== undefined && sectionArr.includes(self.sectionratesArr[i].section_id.value)) {
                self.sectionratesArr[i].section_error_msg = " Section Rate has been already added.";
                error = true;
              }

              if (self.sectionratesArr[i].section_id == null || !self.sectionratesArr[i].section_id.value) {
                self.sectionratesArr[i].section_error_msg = "Section Rate Required.";
                error = true;
              } else {
                sectionArr.push(self.sectionratesArr[i].section_id.value);
              }



              if (self.sectionratesArr[i].section_value == null || self.sectionratesArr[i].section_value == 0) {
                self.sectionratesArr[i].section_value_error_msg = "Section Value Required.";
                error = true;
              } else {

                // check amount is valid or not
                if (self.sectionratesArr[i].section_value && self.sectionratesArr[i].section_value.includes(',')) {
                  self.sectionratesArr[i].section_value = self.sectionratesArr[i].section_value.replace(',', '');
                }
                if (!self.sectionratesArr[i].section_value.match(checkNumber)) {
                  self.sectionratesArr[i].section_value_error_msg = "Section Value is not valid.";
                  error = true;
                }
              }
            }

            if (error === false) {
              var conCpiRateIdArr = [];
              var sectioIdArr = [];
              var sectionValueArr = [];
              var effectiveDateArr = [];
              var conAssRateIdArr = [];

              // for (var i = 0; i < self.sectionratesArr.length; i++) {
              //   conAssRateIdArr.push(self.sectionratesArr[i].id);
              //   if (self.sectionratesArr[i].cpi_rate_id != null && self.sectionratesArr[i].cpi_rate_id.value && !self.cpi_waived) {
              //     conCpiRateIdArr.push(self.sectionratesArr[i].cpi_rate_id.value);
              //   }

              //   sectioIdArr.push(self.sectionratesArr[i].section_id.value);
              //   sectionValueArr.push(self.sectionratesArr[i].section_value);
              //   effectiveDateArr.push(self.sectionratesArr[i].cpi_effective_date);
              // }

              var fields = {
                contract_asset_id: segments[3],
                secArr:self.sectionratesArr
                // cpi: conCpiRateIdArr,
                // section_id: sectioIdArr,
                // section_val: sectionValueArr,
                // cnt_ast_rt_id: conAssRateIdArr,
                // effective_date: effectiveDateArr,
              };
              self.loading = true;
              $.ajax({
                url: process.env.ROOT_API + "/contractassetcpidetail/add",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                  self.loading = false;

                  if (data.duplicate != undefined && data.duplicate.length > 0){
                    self.$swal('',data.duplicate+' Already added with the same date','info');
                    return;
                  }
                  // Changing the value because we are loading CPI Rate history if we added new cpi rate
                  self.$parent.contractCpiRateHistoryVal = "dontLoadList";

                  if (data.status === "success") {
                    var path = window.location.pathname;

                    var segments = path.split("/");
                    self.isupdate = false;
                    self.ContractCPIRateData();
                    self.$parent.rate_history_id = 0;

                  } else {
                    if (data.content.length > 0) {
                      var err = "<ul>";
                      $(".alert-contract").empty();

                      for (var i = 0; i < data.content.length; i++) {
                        err += "<li>" + data.content[i] + "</li>";
                      }
                      err += "</ul>";
                      $(".alert-contract").append(err);
                      $(".alert-contract").addClass("show");
                    }
                  }
                },
                error: function (jqXHR) {
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR, true, 'contract-asset-detail-create')
                }
              });
            }
          },
          addLine($event, index) {

            var self = this;
            self.sectionratesArr[index].section_value_error_msg = "";
            self.sectionratesArr[index].section_error_msg = "";
            self.sectionratesArr[index].cpi_rate_error_msg = "";
            self.sectionratesArr[index].effective_date_error_msg = "";

            var efDate = '';
            var comment = '';
                var sectionValue = $($event.target).closest('.validation-msg').find('.section-value').val();

                if ( self.sectionratesArr[index].section_value != null && self.sectionratesArr[index].section_value != "" && self.sectionratesArr[index].section_id != null && self.sectionratesArr[index].section_id != ""
                // && self.sectionratesArr[index].cpi_rate_id != null && self.sectionratesArr[index].cpi_rate_id != ""
                 ) {
                    if (self.is_add_rate){
                      if (self.sectionratesArr[index] != undefined){
                        efDate = self.sectionratesArr[index].cpi_effective_date;
                        comment = self.sectionratesArr[index].comment;
                      }
                       self.sectionratesArr.push({
                          id:0,
                          section_id: null,
                          section_value: null,
                          cpi_rate_id: null,
                          // rate_increase_percent: null,
                          // limit_percent: null,
                          section_error_msg: "",
                          cpi_effective_date: efDate,
                          section_value_error_msg: "",
                          cpi_rate_error_msg: "",
                          comment: comment,
                          section_type: '',
                          // rate_increase_error_msg: "",
                          // limit_percent_error_msg: "",
                      })
                    }else{
                      self.sectionratesArr.push({
                        id:0,
                        section_id: null,
                        section_value: null,
                        cpi_rate_id: null,
                        // rate_increase_percent: null,
                        // limit_percent: null,
                        section_error_msg: "",
                        section_value_error_msg: "",
                        cpi_rate_error_msg: "",
                        comment: "",
                        section_type: '',
                        // rate_increase_error_msg: "",
                        // limit_percent_error_msg: "",
                    })
                    }


                } else {

                    if (self.sectionratesArr[index].section_id == null || !self.sectionratesArr[index].section_id.value) {
                        self.sectionratesArr[index].section_error_msg = "Section Rate Required.";
                    }

                    if (self.sectionratesArr[index].section_value == null || self.sectionratesArr[index].section_value == "" || self.sectionratesArr[index].section_value == 0) {
                        self.sectionratesArr[index].section_value_error_msg = "Section Value Required.";
                    }

                  if (self.sectionratesArr[index].cpi_effective_date == null || self.sectionratesArr[index].cpi_effective_date == "" || self.sectionratesArr[index].cpi_effective_date == 0) {
                    self.sectionratesArr[index].effective_date_error_msg = "Date Value Required.";
                  }

                    // if (self.sectionratesArr[index].cpi_rate_id == null || self.sectionratesArr[index].cpi_rate_id == "") {
                    //     self.sectionratesArr[index].cpi_rate_error_msg = "CPI Rate Required.";
                    // }

                    // if (self.sectionratesArr[index].rate_increase_percent == null || self.sectionratesArr[index].rate_increase_percent == "") {
                    //     self.sectionratesArr[index].rate_increase_error_msg = "Rate Percent Required.";
                    // }

                    // if (self.sectionratesArr[index].limit_percent == null || self.sectionratesArr[index].limit_percent == "") {
                    //     self.sectionratesArr[index].limit_percent_error_msg = "Limit Percent Required.";
                    // }
                }

            },
            getSectionTypes(){

            var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/contracttype/getsectionrate",
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {

                            self.sectionTypes = data.content;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.generateStatusCodeMessage(jqXHR,true,'contract-asset-get-section-rate')
                    }
                });
            },

          loadCPiRate(is_add,flag) {
            var self = this;
            if (is_add) {
              self.is_add_rate = true
            } else {
              self.is_add_rate = false
            }
            self.isupdate = true;
            self.getSectionTypes();
            if (flag == 'update'){
              self.getRateHistoryData(self.rateHistoryId);
            }else{
              self.getContrgetContractRate(self.$parent.contract_id, is_add);
            }
          },
            getSectionRates:function(is_add){
                var self = this;

                var path = window.location.pathname;
                var segments = path.split("/");
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/get-section-rates/search",
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType:"json",
                    data:{
                        contract_type_id: 0,
                        vehicle_type_id: 0,
                        contract_asset_id: segments[3],
                    },
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.sectionratesArr = [];
                            //self.sectionratesArr = data.content;
                            if(data.cpi_waived==1 || data.national_lease ==1){
                                self.cpi_waived = true;
                            }
                            //set value for section selected if update page
                          if(!is_add){
                            for ( var i=0; i<data.content.length; i++ ) {
                              //initialize array
                              self.sectionratesArr.push({
                                id:null,
                                section_id: null,
                                section_value: null,
                                cpi_rate_id:null,
                                section_error_msg: "",
                                section_value_error_msg: "",
                                cpi_rate_error_msg: "",
                                comment: "",
                                section_type: ''
                              })

                              self.sectionratesArr[i].id = (data.content[i].id) ? data.content[i].id : 0;
                              self.sectionratesArr[i].section_id = (data.content[i].section_id != null && data.content[i].section_id != undefined)?{value: data.content[i].section_id, text: data.content[i].srName,code:data.content[i].code,section_type:data.content[i].section_type}:"";
                              self.sectionratesArr[i].section_value = data.content[i].section_value;
                              if (data.content[i].cpi_rate_id){

                                self.sectionratesArr[i].cpi_rate_id =(data.content[i].cpi_increase_percent!='')?{text:"CPI:"+data.content[i].cpi_increase_percent+ " | Rate:" +data.content[i].rate_increase_percent +" | Limit:"+data.content[i].limit_percent,value:data.content[i].cpi_rate_id}:'';

                              }else{
                                self.sectionratesArr[i].cpi_rate_id = '';
                              }
                              self.sectionratesArr[i].comment = data.content[i].comment;
                              self.sectionratesArr[i].section_type = data.content[i].section_type;
                              setTimeout(function(){

                                self.onSectionChange('','','on_load');

                              },500);
                              // self.sectionratesArr[i].rate_increase_percent = data.content[i].rate_increase_percent;
                              // self.sectionratesArr[i].limit_percent = data.content[i].limit_percent;
                            }
                          }else{
                            self.sectionratesArr.push({
                              id:null,
                              section_id: null,
                              section_value: null,
                              cpi_rate_id:null,
                              cpi_effective_date: null,
                              section_error_msg: "",
                              section_value_error_msg: "",
                              cpi_rate_error_msg: "",
                              effective_date_error_msg: "",
                              comment:'',
                              section_type: ''
                            })
                          }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'contract-asset-get-section-rate-data')
                    }
                });
            },

            ContractCPIRateData(){

               var self = this;

                var path = window.location.pathname;
                var segments = path.split("/");
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/get-section-rates/search",
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType:"json",
                    data:{
                        contract_type_id: 0,
                        vehicle_type_id: 0,
                        contract_asset_id: segments[3],
                    },
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            if(data.cpi_waived==1 || data.national_lease ==1){
                                self.cpi_waived = true;
                            }

                              if(data.content.length==1 && data.content[0].section_id==null){
                                self.rows = null;
                                self.rateFound=false;
                              }else{
                                self.rows = data.content;
                                self.rateFound=true;
                              }
                            // self.totalRecords = data.content.totalRecords;
                        }
                    },
                    error: function (jqXHR, exception) {

                        self.generateStatusCodeMessage(jqXHR,true,'contract-asset-get-section-rate-data-view')
                    }
                });

            },
            removeLine (lineId,id) {

                var self = this;
                if ( id == 0 ) {
                    if (!self.blockRemoval) self.sectionratesArr.splice(lineId, 1)
                } else {
                  self.$swal({
                    title: '',
                    text: 'This will delete the rate. Do you want to proceed?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                  }).then((result) => {
                    if(result.value){
                      $.ajax({
                          url: process.env.ROOT_API + "/contractassetdetail/remove-contract-asset-section-rate",
                          type: "POST",
                          data: {'id':id},
                          headers: this.ajxHeaders,
                          dataType: "json",
                          success: function (data) {
                              if (data.status == "success" ) {
                                  self.sectionratesArr.splice(lineId, 1);
                              }

                          },
                          error: function (jqXHR, exception) {

                          },
                      });
                    }
                  });
                }

            },

            onSectionChange:function(evt,index,flag){
                var self = this;

                if (flag == 'change'){
                    console.log(evt);
                    if (evt.code.toLowerCase() == 'fixed'){
                        if (self.cpiRateArr.length > 0){
                            for( var i=0;i < self.cpiRateArr.length;i++){
                                if (self.cpiRateArr[i].for == 'fixed' && self.cpiRateArr[i].default == 1 && (self.sectionratesArr[index].cpi_rate_id == null || self.sectionratesArr[index].cpi_rate_id == '')){

                                    self.sectionratesArr[index].cpi_rate_id = {text:self.cpiRateArr[i].text,value:self.cpiRateArr[i].value};

                                }
                            }
                        }
                    }else{
                        if (self.cpiRateArr.length > 0){
                            for( var i=0;i < self.cpiRateArr.length;i++){
                                // alert(self.cpiRateArr[i].for);
                                if (self.cpiRateArr[i].for == 'variable' && self.cpiRateArr[i].default == 1 && (self.sectionratesArr[index].cpi_rate_id == null || self.sectionratesArr[index].cpi_rate_id == '')){

                                    self.sectionratesArr[index].cpi_rate_id = {text:self.cpiRateArr[i].text,value:self.cpiRateArr[i].value};

                                }
                            }
                        }

                    }
                }else{
                    for (var j = 0;j < self.sectionratesArr.length;j++){

                        if (self.sectionratesArr[j].section_id.code.toLowerCase() == 'fixed'){
                            if (self.cpiRateArr.length > 0){
                                for( var i=0;i < self.cpiRateArr.length;i++){
                                    if (self.cpiRateArr[i].for == 'fixed' && (self.sectionratesArr[j].cpi_rate_id == null || self.sectionratesArr[j].cpi_rate_id == '')){

                                        self.sectionratesArr[j].cpi_rate_id = {text:self.cpiRateArr[i].text,value:self.cpiRateArr[i].value};

                                    }
                                }
                            }
                        }else{
                            if (self.cpiRateArr.length > 0){
                                for( var i=0;i < self.cpiRateArr.length;i++){
                                    // alert(self.cpiRateArr[i].for);
                                    if (self.cpiRateArr[i].for == 'variable' && (self.sectionratesArr[j].cpi_rate_id == null || self.sectionratesArr[j].cpi_rate_id == '')){

                                        self.sectionratesArr[j].cpi_rate_id = {text:self.cpiRateArr[i].text,value:self.cpiRateArr[i].value};

                                    }
                                }
                            }

                        }
                    }
                }

            },
            titleCase(str) {
                if (str == null){
                    return;
                } else{
                    var value = str.toString()
                    return value.charAt(0).toUpperCase() + value.slice(1)
                }
            },

        }
    };
</script>



// WEBPACK FOOTER //
// src/components/ContractCPITabView.vue